import { Box, Divider, Icon } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import UserProfileJSON from '../../../../json/agencyusers/userprofile';
import ExtUserProfileJSON from '../../../../json/companyInternal/Users/profilecompanyuser';
import { getEnvVariable } from '../../../../modules/environmentalList';
import CustomPopover from '../../../controls/components/popover';
import FormSwitch from '../../../controls/components/switch';
import { GetData } from '../../../controls/helpers/requests';
import defaultImage from '../../../resources/Default-UserImg.jpg';
import { logOut } from '../../../security/actions';
import VersionHistory from '../../../versionhistory/laoacs';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ConfirmationPopup from '../../../controls/components/confirmationPopup';

const useStyles = makeStyles((theme) => ({
    typography: {
        padding: theme.spacing(2),
    },
    bottomstyle: {
        position: 'absolute',
        bottom: 0,
        backgroundColor: '#0000000a',
        width: '100%',
        height: '25%'
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    split: {
        height: '100%',
        width: '40%',
        position: 'fixed',
    },
    left: {
        left: 0,
    },
    right: {
        right: 0,
    }
}));


// function getLocalStorageValue() {
//     const value = localStorage.getItem('menulistview'|| 'Y');
//     return value ? JSON.parse(value) : null;
//   }
function SimplePopover(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [user, setUser] = React.useState(props.userProfile);
    const [loading, setLoading] = React.useState(false);
    const [openSlide, setopenSlide] = React.useState(false);
    const [drawer, setdrawer] = React.useState(false);
    const [versionHistory, setVersionHistory] = React.useState(false);
    const [impersonate, setImpersonate] = React.useState(false);
    const [moveSidebartoTop, setmoveSidebartoTop] = useState(localStorage.getItem('menulistview') || 'Y')
    const [openMobileOptions, setOpenMobileOptions] = useState(false)
    const [mobileAnchor, setMobileAnchor] = useState(null)
    const [openConfirmSlide, setopenConfirmSlide] = useState(false)
    let menulist = (localStorage.getItem("menulistview") !== 'Y' ? 'ON' : 'OFF')

    const history = useHistory()

    const mobileOptions = [
        {
            text: 'Notifications',
            Icon: 'notifications_active',
            onClick: () => props.handleNotificationClick()
        },
        {
            text: 'Help',
            Icon: 'contact_support',
            onClick: () => { window.open(getEnvVariable('HelpUI')) }
        },
    ]

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {

        if (props.accessPermissions) {
            let url = props.accessPermissions.portal === 'I' ? getEnvVariable('MasterAdmin') + `/api/${getEnvVariable('ModuleKey')}InternalUser/UserById/` : getEnvVariable('MasterAdmin') + `/api/ExternalUser/` + getEnvVariable('ModuleKey') + `/`;
            if (props.accessPermissions.userId) {
                GetData(url + props.accessPermissions.userId).then(res => {
                    setUser(res);
                    setLoading(false);
                })
            }
        }
        else props.history.push('/');
    }, [anchorEl]);


    useEffect(() => {
        setUser(props.userProfile)
    }, [props.userProfile])

    const profile = () => {
        if (props.accessPermissions && props.accessPermissions.portal === 'I') {
            if (props.accessPermissions.userId) {
                setopenSlide(!openSlide)
            }
            else {
                props.history.push('/accessdenied');
            }
        }
        else if (props.accessPermissions && props.accessPermissions.portal === 'E') {
            if (user && props.accessPermissions.userId) {
                setopenSlide(!openSlide)
            }
            else if (props.accessPermissions.userId) {
                setopenSlide(!openSlide)
                setLoading(true)
            }
            else {
                props.history.push('/accessdenied');
            }
        }
    }

    // const signout = () => {
    //     props.history.push('/logout');
    //     localStorage.removeItem('internaltoken');
    //     localStorage.removeItem('externaltoken');
    //     localStorage.removeItem('profile');
    //     logOut();
    //     window.location.reload(true);
    // }
// Code linked to the auth UI page
    const signout = () => {
        // localStorage.clear();
        window.location.replace(getEnvVariable('AuthorizationScreen') + 'user/logout');
    }

    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleImpersonate = (value) => {
        localStorage.setItem('impersonate', value)
        window.location.reload()

    }

    const getGreetings = () => {
        const currentHour = new Date().getHours();
        let greeting;
        if (currentHour < 12) {
            greeting = "Good Morning";
        } else if (currentHour < 18) {
            greeting = "Good Afternoon";
        } else {
            greeting = "Good Evening";
        }
        return greeting;
    }

    // const getRoles = () => {
    //     let roles = ''
    //     if (props.accessPermissions && props.accessPermissions.roles) {
    //         props.accessPermissions.roles.forEach(each => {
    //             roles += `${each.name}, `
    //         })
    //     }
    //     return roles.substring(0, roles.length - 2)
    // }

    const getHighestPriorityRole = (userRoles) => {
        let highestPriorityRole = null;
        let highestPriority = Infinity;
        userRoles.forEach(role => {
            if (roles[role] && roles[role] < highestPriority) {
                highestPriorityRole = role;
                highestPriority = roles[role];
            }
        });
        if (highestPriorityRole)
            highestPriorityRole = highestPriorityRole.replace(/([A-Z])/g, ' $1').trim();
        return highestPriorityRole;
    };

    const handlemenutop = () => {
        setopenConfirmSlide(false)
        setmoveSidebartoTop(moveSidebartoTop === 'Y' ? 'N' : 'Y')
        localStorage.setItem("menulistview", moveSidebartoTop === 'Y' ? 'N' : 'Y')
        props.handlefieldchange(moveSidebartoTop === 'Y' ? 'N' : 'Y');
        window.location.reload();
    }

    const handlemenutopConfirmation = (e) => {
        //setmoveSidebartoTop(e.target.value);
        setopenConfirmSlide(true)
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const EachComp = props.compmap[UserProfileJSON.type];
    const roles = {
        "SuperAdmin": 2,
        "SystemAdmin": 1,
        "Administrator": 3,
        "RequestAdministrator": 4,
        "Official": 5,
        "Preparer": 6,
    };
    const roleWithSpaces = () => {
        const { accessPermissions } = props;
        if (accessPermissions && accessPermissions.roles && accessPermissions.roles.length > 0)
            return getHighestPriorityRole(accessPermissions.roles);
        else return 'Non Admin';
    };

    const lastLoginDate = new Date(JSON.parse(localStorage.getItem('loginDate')));
    const formattedDate = `${lastLoginDate.getMonth() + 1}/${lastLoginDate.getDate()}/${lastLoginDate.getFullYear()}`;
    const formattedTime = lastLoginDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
        < >
            {/* {!props.mobile && */}
            <IconButton title='Profile' onClick={handleClick} className='pt-2'>
                <Avatar alt="Profile" src={(user && user.UserImageUI) || defaultImage} style={{ height: props.mobile ? 30 : 35, width: props.mobile ? 30 : 35, padding: 0 }} />
            </IconButton>
            {/* } */}
            {/* {
                props.mobile && <MenuItem onClick={handleClick}>
                    <Icon>account_box</Icon> &nbsp; Profile
                </MenuItem>
            } */}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                PaperProps={{
                    style: {
                        minHeight: 221,
                        minWidth: 320,
                    },
                }}
            >
                <div className='m-3'>
                    <Typography variant='body' style={{ fontWeight: 'bold' }}>{getGreetings()}</Typography>
                    <Typography variant='body'>{', ' + props.accessPermissions.name}   </Typography>
                    <br />
                    <Typography variant='body'>
                        {localStorage.getItem('impersonate') &&
                            getEnvVariable('AccessPortal') === 'E' && <small>Impersonated :
                                {(JSON.parse(localStorage.getItem('profile')).impersonateAccess.find(each => each.id === JSON.parse(localStorage.getItem('impersonate'))) || {}).name}</small>}
                    </Typography>
                     <Typography variant='caption' color='inherit'>{roleWithSpaces()}
                     {getEnvVariable('AccessPortal') === 'I' && <span className='ms-5'>   Version:<Button variant="text" size='small' color="primary" onClick={() => { setVersionHistory(true) }}>{process.env.REACT_APP_RELEASE_NOTES}</Button></span>}
                    </Typography>
                    <Divider />
                    <div style={{
                        margin: 2,
                        padding: 2,
                        backgroundColor: 'rgb(239, 242, 245)',
                        //   border: '1px solid #000',
                        borderRadius: '2px'
                    }}>
                        {/* <Button size="small" color="primary" onClick={profile}><Icon>settings</Icon><div className='mx-1' />  Account Settings</Button><br /> */}
                        <Button size="small" color="primary" onClick={profile}><Icon>account_circle</Icon><div className='mx-1' />   Profile</Button><br />
                        <Button size="small" style={{ color: '#ab003c' }} onClick={signout}><Icon style={{ color: '#ab003c' }}>logout</Icon> <div className='mx-1' />  Log Out</Button><br />
                    </div>
                    {getEnvVariable('AccessPortal') === 'E' && JSON.parse(localStorage.getItem('profile')).impersonateAccess && <Button size="small" color="primary" onClick={(event) => setImpersonate(event.currentTarget)}>Impersonate</Button>}
                    <Popover
                        open={Boolean(impersonate)}
                        anchorEl={impersonate}
                        onClose={() => setImpersonate(null)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}

                    >  {props.accessPermissions && props.accessPermissions.impersonateAccess && props.accessPermissions.impersonateAccess.map(each => {
                        return <MenuItem onClick={() => handleImpersonate(each.id)} value={each.id}  >         {each.name}                         </MenuItem>
                    })}

                    </Popover>
                    {loading && <div><Typography className='ps-3 pt-1' variant='caption'>Loading</Typography></div>}
                    {menulist === 'ON' && <ConfirmationPopup value={openConfirmSlide ? 'Y' : 'N'} onClose={() => setopenConfirmSlide(false)} title='Navigation Bar'
                        description='Would you like to turn ON the navigation? Please note that the page will reload and any unsaved changes will be reverted.'
                        onSubmit={() => { setopenConfirmSlide(false); handlemenutop() }} />}
                    {menulist === 'OFF' && <ConfirmationPopup value={openConfirmSlide ? 'Y' : 'N'} onClose={() => setopenConfirmSlide(false)} title='Navigation Bar'
                        description='Would you like to turn OFF the navigation? Please note that the page will reload and any unsaved changes will be reverted.'
                        onSubmit={() => { setopenConfirmSlide(false); handlemenutop() }} />}
                    <Box style={{
                        margin: 2,
                        padding: 2,
                        backgroundColor: 'rgb(239, 242, 245)',
                        fontSize: '10px',
                        borderRadius: '2px'
                    }}>
                        <FormSwitch name="MovetoTop" label={<small>{'Navigation bar'}</small>} extraProps={{
                            "transformProps": {
                                "Y": true,
                                "N": false,
                                "true": "Y",
                                "false": "N"
                            }
                        }} handleFieldValue={(e) => handlemenutopConfirmation(e)} value={moveSidebartoTop} />
                    </Box>
                    <div style={{
                        margin: 2,
                        padding: 2,
                        backgroundColor: 'rgb(239, 242, 245)',
                        //   border: '1px solid #000',
                        borderRadius: '2px'
                    }}>
                        Last Login : <DateRangeIcon style={{ fontSize: 15 }} />{formattedDate} <AccessTimeIcon style={{ fontSize: 15 }} /> {formattedTime} </div>
                </div>
                <CustomPopover content={mobileOptions} onClose={() => { setOpenMobileOptions(!openMobileOptions); setMobileAnchor(null) }} open={openMobileOptions} anchorEl={mobileAnchor} />
                {props.mobile && isMobile && <Button className='col-12' onClick={(e) => { setOpenMobileOptions(!openMobileOptions); setMobileAnchor(e.currentTarget) }}>   <ExpandMoreIcon /></Button>}
            </Popover>
            {
                openSlide && UserProfileJSON && props.accessPermissions.portal === 'I' &&
                <EachComp {...UserProfileJSON} key={UserProfileJSON.key} handleSlide={profile} accessPermissions={props.accessPermissions} compmap={props.compmap} dataItem={{ ...props.accessPermissions, CompanyId: user && user.CompanyId ? user.CompanyId : null, IsOfficial: user && user.IsOfficial ? user.IsOfficial : 'N' }} />
            }
            {
                !loading && openSlide && ExtUserProfileJSON && props.accessPermissions.portal === 'E' &&
                <EachComp {...ExtUserProfileJSON} key={ExtUserProfileJSON.key} handleSlide={profile} accessPermissions={props.accessPermissions} compmap={props.compmap} dataItem={{ ...props.accessPermissions, CompanyId: user && user.CompanyId ? user.CompanyId : null, IsOfficial: user && user.IsOfficial ? user.IsOfficial : 'N' }} />
            }
            {versionHistory && <VersionHistory handleBackSlider={() => { setVersionHistory(false) }} backbutton={true} />}
        </>

    );
}

const mapProps = (state) => {
    return { user: state.authentication.user }
}

const mapActions = dispatch => {
    return bindActionCreators({ logOut }, dispatch);
}

SimplePopover = connect(mapProps, mapActions)(SimplePopover);
export default withRouter(SimplePopover);